import React from 'react'
import { Outlet } from 'react-router-dom'

const Device = () => {
  return (
    <>
      <Outlet />
    </>
  )
}

export default Device
